import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import classes from './mobileRealTalk.css';

const leftQuoteMark = '\u201C';

const QuoteSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
      <Slider {...settings}>
        <div>
          <div className={classes.quote}>
            {leftQuoteMark}
          </div>
          <blockquote className={classes.largeQuoteText}>
            If you want to win your league, use The Huddle. It’s that simple.
            <span className={classes.largeQuoteMark}>”</span>
          </blockquote>
          <p className={classes.attributionNameText}>Paul Friel</p>
          <p className={classes.attributionLabelText}>WCOFF $200,000 Champion</p>
        </div>
        <div>
          <div className={classes.quote}>
            {leftQuoteMark}
          </div>
          <blockquote className={classes.mediumQuoteText}>
            I have been a member of The Huddle for 9 years. I find The Huddle{'’'}s
            information very helpful... The Huddle has the best {'‘'}Ease of
            Schedule{'’'} ranking system I have ever seen.
            <span className={classes.mediumQuoteMark}>”</span>
          </blockquote>
          <p className={classes.attributionNameText}>Kenny Hegmann</p>
          <p className={classes.attributionLabelText}>
            Mr. Fantasy Football $35,000 Champion
          </p>
        </div>
        <div>
          <div className={classes.quote}>
            {leftQuoteMark}
          </div>
          <blockquote className={classes.mediumQuoteText}>
            I{'’'}ve been a Huddle member for two years… This year we took
            everything: points, record, ranking, $$$$$, and the championship!
            Your timely insights helped us draft and maintain the best team from
            top to bottom throughout the entire season. Thanks a million and see
            you next season.
            <span className={classes.mediumQuoteMark}>”</span>
          </blockquote>
          <p className={classes.attributionNameText}>Jerry Mitchell</p>
          <p className={classes.attributionLabelText} />
        </div>
      </Slider>
  );
};

export default QuoteSlider;



// WEBPACK FOOTER //
// ./src/app/components/Footer/MobileFooter/QuoteSlider.js